<template>
  <div >
    <div class="forms-container">
      <el-form :model="searchForm" class="search-form" ref="searchFormRef">
        <el-form-item label="" prop="couponSearchContent">
          <el-input
              style="width:300px"
              :maxlength="100"
              v-model="searchForm.couponSearchContent"
              placeholder="券商品名称/商品ID"
          />
        </el-form-item>
        <el-form-item label="" prop="darenSearchContent">
          <el-input
              style="width:300px"
              :maxlength="100"
              v-model="searchForm.darenSearchContent"
              placeholder="达人昵称/达人ID"
          />
        </el-form-item>
        <el-form-item label="" prop="orderNo">
          <el-input
              style="width:300px"
              :maxlength="100"
              v-model="searchForm.orderNo"
              placeholder="券订单号"
          />
        </el-form-item>
        <el-form-item label="" prop="orderUUID">
          <el-input
              style="width:300px"
              :maxlength="100"
              v-model="searchForm.orderUUID"
              placeholder="影票订单号"
          />
        </el-form-item>
        <el-form-item>
          <el-date-picker
              v-model="searchForm.timeArr"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="daterange"
              range-separator="-"
              start-placeholder="用券开始日期"
              end-placeholder="用券结束日期"
              :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <!-- 操作按钮 -->
          <el-button type="warning" @click="onFormSearch">查询</el-button>
          <el-button type="warning" plain @click="onFormReset">重置</el-button>
          <el-button type="primary" @click="onExport" :disabled="exportLoading" :loading="exportLoading">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableList.list" v-loading="loading" highlight-current-row border style="width: 100%">
      <el-table-column prop="couponName" label="券商品名称"/>
      <el-table-column prop="templateCode" label="券商品ID" />
      <el-table-column prop="orderNo" label="券订单编号" />
      <el-table-column prop="code" label="券码" />
      <el-table-column prop="orderId" label="影票订单号" />
      <el-table-column prop="receiveTime" label="领券时间" />
      <el-table-column prop="useTime" label="用券时间" />
      <el-table-column prop="couponPayAmountBd" label="券售价" />
      <el-table-column prop="couponPriceBd" label="券面值" />
      <el-table-column prop="commissionRate" label="券佣金比例（%）" />
      <el-table-column prop="commissionBd" label="券总佣金" />
      <el-table-column prop="darenName" label="达人昵称" />
      <el-table-column prop="douyinid" label="达人抖音ID" />
      <el-table-column prop="darenCommissionRate" label="达人佣金比例（%）" />
      <el-table-column prop="darenCommissionBd" label="达人佣金" />
      <el-table-column prop="agentCommissionBd" label="我的服务费" />
    </el-table>
    <el-pagination
        v-if="tableList.total > 0"
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="tableList.currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="tableList.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableList.total"
    >
    </el-pagination>
  </div>
</template>

<script>
import debounce from "@/utils/debounce.js";
import poi from "@/api/poi";
import {goExportCenter} from "../../../../../utils/tool";
const PoiModel = new poi();
export default {
  data() {
    return {
      searchForm: {
        couponSearchContent: '',
        darenSearchContent: '',
        orderNo: '',
        orderUUID: '',
        timeArr: null
      },
      openParams:{},
      params: {
        pageNo: 1,
        pageSize: 10,
      },
      loading: false,
      tableList:{
        pageSize: 10,
        currentPage: 1,
        total: 0,
        list:[],
      },
      exportLoading: false
    }
  },
  created() {
    this.getList()
  },
  methods:{
    getParams(){
      const params = {
        ...this.searchForm
      }
      params.useStartTime = this.searchForm.timeArr ? this.searchForm.timeArr[0] : '';
      params.useEndTime = this.searchForm.timeArr ? this.searchForm.timeArr[1] : '';
      delete params.timeArr
      return {
        ...this.openParams,
        ...params
      }
    },
    async getList() {
      this.loading = true
      const res = await PoiModel.getSettledCommission({
        ...this.getParams(),
        pageNo: this.params.pageNo,
        pageSize: this.params.pageSize,
      });
      if(!res.data.success) {
        this.$message.error(res.data.message);
        return;
      }
      this.tableList.list = res.data.data.list || [];
      this.tableList.total = res.data.data.total || 0;
      this.loading = false;
      this.tableList.currentPage = res.data.data.pageNo;
      this.tableList.pageSize = res.data.data.pageSize;
    },
    // 表单搜素
    onFormSearch() {
      debounce(
          () => {
            this.$refs['searchFormRef'].validate((valid) => {
              if (valid) {
                this.params.pageNo = 1;
                this.getList();
              } else {
                return false;
              }
            });
          },
          500,
          true
      );
    },
    reset() {
      this.searchForm = {
        couponSearchContent: '',
        darenSearchContent: '',
        orderNo: '',
        orderUUID: '',
        timeArr: null
      }
      this.params.pageNo = 1;
      this.params.pageSize = 10;
      this.$refs['searchFormRef'] && this.$refs['searchFormRef'].resetFields();
    },
    onFormReset() {
      debounce(() => {
        this.reset()
        this.getList()
      }, 1000, true)
    },
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.getList();
    },
    async onExport(){
      const params = this.getParams();
      if(!params.useStartTime || !params.useEndTime){
        this.$message.error('请选择日期')
        return;
      }
      this.exportLoading = true;
      const res = await PoiModel.exportMySettledListExport({
        ...params,
      }).finally(()=>{
        this.exportLoading = false;
      });
      if(!res.data.success) {
        this.$message.error(res.data.message);
        return;
      }
      this.exportLoading = false;

      await goExportCenter()
    }
  },
};
</script>

<style>
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/douyin/poiDistribution/components/commissionList.vue